<div
  *ngIf="isSpinner"
  class="spinner"
>
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <img loading="lazy" src="assets/icons/spinner.ico" />
</div>
